export enum CHAT_MESSAGE_STATE {
    SYNCED = 'synced',
    SYNCING = 'syncing',
    ERROR = 'error',
}
